
    import FormatterService from "@/service/FormatterService";

    export default {
        name: 'InvestedFunds',
        props: {
            share: Object
        },
        data() {
            return {
                headers: [
                    { text: this.$t('component.share.investedFunds.headers.fund'), value: 'name' },
                    { text: this.$t('component.share.investedFunds.headers.volume'), value: 'volume', align: 'start', width: '132px' },
                    { text: this.$t('component.share.investedFunds.headers.percentage'), value: 'asset_percentage', align: 'start', width: '132px' }
                ],
            }
        },
        computed: {
            topInvestedFunds() {
                return this.format(this.share.investedFunds.slice(0, 5))
            },
        },
        methods: {
            format(investedFunds) {
                return investedFunds.map(row => {
                    const result = Object.assign({}, row)
                    result.volume = this.formatter.currency(result.volume / 1000, '')
                    result.asset_percentage = this.formatter.percent(result.asset_percentage)
                    return result
                })
            }
        },
        created() {
            this.formatter = new FormatterService()
        }
    }
